import React, { useContext, useEffect, useState } from "react";
import { Button, Label, Modal, TextInput } from "flowbite-react";
import Swal from "sweetalert2";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import DataTable from "react-data-table-component";
import engineGif from "../image/engine.gif";
import Button_submit from "../components/Button_submit";
import Head_data from "../components/Head_data";

const IncomeCategory = ({ theme }) => {
    const { globalValue } = useContext(GlobalContext);
    const [categories, setCategories] = useState([]);
    const [modalCatOpen, setModalCatOpen] = useState(false);
    const [catMode, setCatMode] = useState("add");
    const [categoryForm, setCategoryForm] = useState({ id: null, category_name: "" });
    const [loading, setLoading] = useState(false);


    const [searchTerm, setSearchTerm] = useState("");
    const [filtered, setFiltered] = useState(categories);


    useEffect(() => {
        const filteredData = categories.filter((branch) =>
            branch.category_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFiltered(filteredData);
    }, [searchTerm, categories]);

    const fetchCategories = () => {
        setLoading(true);
        axios.get(`${globalValue}/category_income_display`)
            .then(res => setCategories(res.data))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    };

    const handleCategorySubmit = () => {
        const url = categoryForm.id ? `${globalValue}/category_edit_income` : `${globalValue}/category_add_income`;
        setLoading(true);
        axios.post(url, categoryForm)
            .then(res => {
                if (res.data.success === 1) {
                    Swal.fire("Success", res.data.message, "success");
                    fetchCategories();
                    setModalCatOpen(false);
                } else {
                    Swal.fire("Error", res.data.message, "error");
                }
            })
            .catch(err => Swal.fire("Error", err.message, "error"))
            .finally(() => setLoading(false));
    };

    const handleCategoryEdit = (cat) => {
        setCategoryForm({ id: cat.id, category_name: cat.category_name });
        setCatMode("edit");
        setModalCatOpen(true);
    };

    const handleCategoryDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(`${globalValue}/category_delete_income`, { id })
                    .then(res => {
                        if (res.data.success === 1) {
                            Swal.fire("Deleted!", res.data.message, "success");
                            fetchCategories();
                        } else {
                            Swal.fire("Error", res.data.message, "error");
                        }
                    })
                    .catch(err => Swal.fire("Error", err.message, "error"))
                    .finally(() => setLoading(false));
            }
        });
    };

    const categoryColumns = [
        {
            name: "ID",
            selector: row => row.id,
            sortable: true,
        },
        {
            name: "Category Name",
            selector: row => row.category_name,
            sortable: true,
        },
        {
            name: "Actions",
            cell: row => (
                <div className="flex gap-3">
                    <button onClick={() => handleCategoryEdit(row)} className="p-2 text-white bg-blue-600 rounded-md hover:bg-blue-700">
                        <i className="fa fa-edit"></i>
                    </button>
                    <button onClick={() => handleCategoryDelete(row.id)} className="p-2 text-white bg-red-600 rounded-md hover:bg-red-700">
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            )
        },
    ];

    useEffect(() => {
        fetchCategories();
    }, []);

    const customStyles = {
        table: {
            style: {
                backgroundColor: "white",
                width: "100%",
                border: "solid 1px rgb(226, 232, 240)",
            },
        },
        headCells: {
            style: {
                backgroundColor: "rgb(226, 232, 240)",
                color: "black",
                fontWeight: "bold",
            },
        },
    };

    return (
        <div
            className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${theme === "dark" ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"
                }`}
        >            {loading && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
                <img src={engineGif} alt="Loading..." className="w-24 h-24" />
            </div>
        )}

            <div
                className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${theme === "dark" ? "bg-gray-800 text-gray-200" : "bg-white text-gray-800"
                    }`}
            >
                <div className="flex justify-between items-center mb-4">
                    <Head_data data="Income Category" font="" size="3xl" color={theme === "dark" ? "text-gray-200" : "text-gray-800"} />
                    <button
                        className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                        onClick={() => {
                            setCategoryForm({ id: null, category_name: "" });
                            setCatMode("add");
                            setModalCatOpen(true);
                        }}
                    >
                        Add Category
                    </button>
                </div>
                <input
                    type="text"
                    placeholder="Search by income category name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                />


                <DataTable
                    columns={categoryColumns}
                    data={filtered}
                    pagination
                    striped
                    highlightOnHover
                    customStyles={customStyles}
                />

                <Modal show={modalCatOpen} onClose={() => setModalCatOpen(false)}>
                    <Modal.Header>{catMode === "add" ? "Add Category" : "Edit Category"}</Modal.Header>
                    <Modal.Body>
                        <div className="space-y-4">
                            <Label>Category Name</Label>
                            <TextInput
                                value={categoryForm.category_name}
                                onChange={(e) => setCategoryForm({ ...categoryForm, category_name: e.target.value })}
                                placeholder="Enter Category Name"
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button_submit onClick={handleCategorySubmit}

                            data={`${catMode === "add" ? "Submit" : "Update"}`}
                        >{catMode === "add" ? "Submit" : "Update"}</Button_submit>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default IncomeCategory;
